/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown>, n: NonNullable<unknown> }} Refusal_Discord_BusyInputs */



/**
* | output |
* | --- |
* | "Discord asked us to slow down. Try again in {seconds} seconds." |
*
* @param {Refusal_Discord_BusyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const refusal_discord_busy = /** @type {((inputs: Refusal_Discord_BusyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refusal_Discord_BusyInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`Discord попросил сбавить темп. Попробуйте снова через ${i?.seconds} секунду.`);
		if (form === "few") return /** @type {LocalizedString} */ (`Discord попросил сбавить темп. Попробуйте снова через ${i?.seconds} секунды.`);
		if (form === "many") return /** @type {LocalizedString} */ (`Discord попросил сбавить темп. Попробуйте снова через ${i?.seconds} секунд.`);
		return /** @type {LocalizedString} */ (`Discord попросил сбавить темп. Попробуйте снова через ${i?.seconds} секунд.`)
	}
	return /** @type {LocalizedString} */ (`Discord asked us to slow down. Try again in ${i?.seconds} seconds.`)
});